'use strict';

/**
 * 取、签、见、撤信息弹窗
 */
angular.module('resCtrModalModule').controller('operRecordsModalCtrl', [
    '$scope',
    '$modalInstance',
    '$location',
    '$anchorScroll',
    'params',
    function($scope, $modalInstance, $location, $anchorScroll, params) {
        // 锚点切换开始
        $scope.goto = function(id) {
            $scope.status.selected = id;
            $location.hash(id);
            $anchorScroll();
        };

        initStatus();
        initData();

        /**
         * [initStatus description]初始化
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.infos = {
                QU: [],
                QIAN: [],
                CHE: [],
                JIAN: [],
                CHONG: [],
            };
            $scope.status = {
                QU: angular.isDefined(params.operFlags) ? (params.operFlags.substr(0, 1) == '1') : false,
                QIAN: angular.isDefined(params.operFlags) ? (params.operFlags.substr(1, 1) == '1') : false,
                JIAN: angular.isDefined(params.operFlags) ? (params.operFlags.substr(2, 1) == '1') : false,
                CHE: angular.isDefined(params.operFlags) ? (params.operFlags.substr(3, 1) == '1') : false,
            };
            $scope.status.isShowTab = true; // 是否显示tab
            // 第一次进来的时候 显示的弹框
            $scope.status.selected = params.selected;
        }

        /**
         * [initData description]初始化
         *
         * @return  {[type]}  [return description]
         */
        function initData() {
            $scope.infos.QU = params.data.QU;
            $scope.infos.QIAN = params.data.QIAN;
            $scope.infos.CHE = params.data.CHE;
            $scope.infos.JIAN = params.data.JIAN;
            $scope.infos.CHONG = params.data.CHONG;
        }

        $scope.close = function() {
            $modalInstance.dismiss();
        };
    },
]);
